/* Time Zone Data Service
 *
 * Angular Module: trackerbase-app.services.time-zone-data-service
 * Injected Resource Class: TimeZone
 */

import angular from "angular";
import ngResource from "angular-resource";

import Assert from "tbAssert";
import TbAppConfigDataServiceModule from "../config/tb-app-config/TbAppConfigDataService";

function TimeZoneResourceFactory (
    $resource,
    TbAppConfigDataService
)
{
    Assert.StrictAssert(TbAppConfigDataService != null, "Assertion Failure: Missing TrackerBase Application Configuration Data Service Dependency");
    const tbServerBaseUrl = TbAppConfigDataService.tbServerBaseUrl;

    const timeZoneApiUrl = `${tbServerBaseUrl}/api/timezones/:countryCode`;
    const timeZoneApiParams = { countryCode: "@countryCode"};


    return $resource(
        timeZoneApiUrl,
        timeZoneApiParams,
        {
            getTimeZones: {
                method: "GET",
                isArray: true
            }
        });
}

TimeZoneResourceFactory.$inject = [ "$resource", "TbAppConfigDataService" ];

export default angular
    .module("trackerbase-app.services.time-zone-data-service", [
        ngResource,
        TbAppConfigDataServiceModule
    ])
    .factory("TimeZone", TimeZoneResourceFactory)
    .name;




//////////////////
// WEBPACK FOOTER
// ./src/services/TimezoneService.js
// module id = aySU
// module chunks = 1